export const FIREBASE_CONFIG_DEV = {
  apiKey: 'AIzaSyAFl9Jz7vmB2ILkPgLMH_eSHKED9LEEQos',
  appId: '1:823901470570:web:f5436661bdf97f302baf13',
  authDomain: 'intellio-dev.firebaseapp.com',
  measurementId: 'G-E50GJMNNRH',
  messagingSenderId: '823901470570',
  projectId: 'intellio-dev',
  storageBucket: 'intellio-dev.firebasestorage.app',
}

export const FIREBASE_CONFIG_PROD = {
  apiKey: 'AIzaSyBN9SmAxpa_3_QpEEn8kgXBwILTbVKblWs',
  appId: '1:474239383051:web:635c7e73245b7a5555b90e',
  authDomain: 'intellio-prod.firebaseapp.com',
  measurementId: 'G-J64FE179CF',
  messagingSenderId: '474239383051',
  projectId: 'intellio-prod',
  storageBucket: 'intellio-prod.firebasestorage.app',
}
